import { useEffect, useState } from "react"
import { FaEllipsis, FaPlus } from "react-icons/fa6"
import { useLocation, useNavigate } from "react-router-dom"
import axios from "axios"
import api from "../config/backend"
import { SpinnerCircular } from "spinners-react"
import { toast } from "react-toastify"

// Calculate total amount of a quote
const calcualteTotal = (quote) => {
    let total = 0

    const items = quote.items

    items.forEach(item => {
        total += (item.quantity * item.rate)
    })

    const subtotal = total

    if (quote.discount) {
        if (quote.discount.ispercentage) {
            total = total - (total * quote.discount.value / 100)
        } else {
            total = total - quote.discount.value
        }
    }

    if (quote.adjustment) {
        total = total + quote.adjustment.value
    }

    let tax = 0

    if (quote.taxdetails) {
        tax = total * quote.taxdetails.rate / 100
    }

    total = total + tax

    return { total, subtotal }
}

const QuotesList = ({ quotesList, setCreateQuote }) => {
    const [activeQuote, setActiveQuote] = useState(0)
    const [quotePreview, setQuotePreview] = useState("")
    const [previewLoading, setPreviewLoading] = useState(false)

    const navigate = useNavigate()

    const token = localStorage.getItem("_crm__token")

    const searchparams = useLocation().search

    const hash = new URLSearchParams(searchparams).get("hash")

    const generatePreview = async (download) => {
        setPreviewLoading(download ? "download" : "preview")

        const { data, status } = await axios.post(`${api}/Accounting/quote-pdf`,
            {
                token,
                hash: hash ? hash : quotesList[activeQuote].hash,
                download
            },
            {
                responseType: download ? "blob" : undefined
            }
        )

        setPreviewLoading(false)

        if (download) {
            const link = document.createElement("a")
            link.href = window.URL.createObjectURL(new Blob([data]))
            link.setAttribute("download", `Quote-${String(quotesList[activeQuote].quoteindex).padStart(6, "0")}.pdf`)
            document.body.appendChild(link)
            link.click()
            return
        }

        if (data.success) {
            setQuotePreview(data.preview)
        }
    }

    const handleShare = async () => {
        setPreviewLoading("share")
        const { data, status } = await axios.post(`${api}/Accounting/quote-share`, { token, hash: quotesList[activeQuote].hash })
        
        setPreviewLoading(false)
        
        if (data.success) {
            navigator.clipboard.writeText(data.link)
            toast.info("Link copied to clipboard")
        }
    }

    const handleConvertInvoice = async () => {
        setPreviewLoading("convert")
        const { data, status } = await axios.post(`${api}/Accounting/convert-quote`, { token, hash: quotesList[activeQuote].hash })
        
        setPreviewLoading(false)
        
        if (data.success) {
            navigate(`/accounting/invoices/edit/${data.invoice.hash}`)
        }
    }

    useEffect(() => {
        generatePreview()
    }, [activeQuote])

    // Auto select the quote that matches hash
    useEffect(() => {
        const getIndex = (value, arr, prop) => arr.findIndex(obj => obj[prop] === value)

        if (hash) {
            const quotePosition = getIndex(hash, quotesList,"hash")

            setActiveQuote(quotePosition)
        }
    }, [hash])

    return (
        <div className="_7fzc">
            <div className="sidebar app-new-quotes-sidebar">
                <div className="header">
                    <div className="all-qutoes">
                        <h3>All Quotes</h3>
                    </div>
                    <div className="hatchet-scab">
                        <button onClick={() => setCreateQuote(true)}><FaPlus /> New</button>
                    </div>
                </div>
                <div className="reacting-eggs">
                    {quotesList.map((quote, index) => {
                        const { total, subtotal } = calcualteTotal(quote)

                        return (
                            <div
                                key={index}
                                className={activeQuote === index ? "stubby-hex active" : "stubby-hex"}
                                onClick={() => {
                                    setActiveQuote(index)
                                    navigate("/accounting/quotes")
                                }}
                            >
                                <div className="spinner-them">
                                    <div className="customer-name">{quote.customer.firstname} {quote.customer.lastname}</div>
                                    <div>{quote.customer.currency.icon}{Math.ceil(total * 100) / 100}</div>
                                </div>
                                <div className="spinner-them">
                                    <div>QT-{String(quote.quoteindex).padStart(6, "0")}</div>
                                    <div>{new Date(quote.quotedate).toDateString()}</div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="squiffed-dint">
                {/* <div className="header">
                    QT-{String(quotesList[activeQuote].quoteindex).padStart(6, "0")}
                </div> */}
                <div className="settings">
                    <div onClick={() => navigate("/accounting/quotes/edit/" + quotesList[activeQuote].hash)}>Edit</div>
                    <div onClick={() => navigate("/accounting/quotes/create/" + quotesList[activeQuote].hash)}>Send e-mail</div>
                    <div className={previewLoading === "share" ? "loading" : undefined} onClick={() => handleShare()}>Share</div>
                    <div className={previewLoading === "download" ? "loading" : undefined} onClick={() => generatePreview(true)}>Download PDF</div>
                    <div className={previewLoading === "convert" ? "loading" : undefined} onClick={() => handleConvertInvoice()}>Convert to Invoice</div>
                </div>
                <div className="drape-cop">
                    {previewLoading === "preview" ? (
                        <div className="woodmen-that">
                            <SpinnerCircular size="70" color="#3b70ad" />
                        </div>
                    ) : (
                        <div className="preview" dangerouslySetInnerHTML={{
                            __html: quotePreview
                        }}>

                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default QuotesList
